import React, { FC, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import WebFont from 'webfontloader';
import PageListComponent from '../../../core/components/pageList/PageListComponent';
import cageBackgroundUrl from '../../../images/cage-min.jpg';
import lineBackgroundUrl from '../../../images/line-min.jpg';
import emptyBackgroundUrl from '../../../images/empty.jpg';
import { AppStateTypes } from '../../../store/appStateTypes';
import { ImageTypeEnum } from '../../imageSettings/imageSettingsTypes';
import { textSettingsChangeIndentRedLine } from '../../textSettings/state/controller';
import { IndentRedLineEnum } from '../../textSettings/textSettingsTypes';

type PropsType = {
  text: string;
};

const ContentContainer: FC<PropsType> = ({ text }) => {
  const dispatch = useDispatch();

  const [fontLoading, setFontLoading] = useState(false);
  const [customImageUrl, setCustomImageUrl] = useState('');

  const {
    fontSize,
    lineHeight,
    indentRight,
    indentLeft,
    indentTop,
    fontType,
    textColor,
    indentRedLine,
    indentLetter,
    indentWord,
    isRandomFontSize,
    isRandomRotateLetter,
    isRandomLineLeftIndent,
  } = useSelector((state: AppStateTypes) => state.textSettings);

  const { imageType } = useSelector((state: AppStateTypes) => state.imageSettings);

  const IMAGE_URLS = {
    [ImageTypeEnum.CAGE]: cageBackgroundUrl,
    [ImageTypeEnum.LINE]: lineBackgroundUrl,
    [ImageTypeEnum.EMPTY]: emptyBackgroundUrl,
    [ImageTypeEnum.CUSTOM]: customImageUrl,
  };

  useEffect(() => {
    try {
      WebFont.load({
        custom: {
          urls: [`fonts/${fontType}.css`],
          families: [fontType],
        },
        loading: () => setFontLoading(true),
        active: () => setFontLoading(false),
      });
    } catch (e) {
      console.error(e);
    }
  }, [fontType]);

  useEffect(() => {
    const customImageNode = document.getElementById('customImage') as HTMLImageElement;

    if (imageType === ImageTypeEnum.CUSTOM) {
      dispatch(textSettingsChangeIndentRedLine(IndentRedLineEnum.CUSTOM));

      if (customImageNode) {
        setCustomImageUrl(customImageNode.src);
      }
    }

    if (imageType === ImageTypeEnum.CAGE) {
      dispatch(textSettingsChangeIndentRedLine(IndentRedLineEnum.CAGE));
    }

    if (imageType === ImageTypeEnum.LINE) {
      dispatch(textSettingsChangeIndentRedLine(IndentRedLineEnum.LINE));
    }

    if (imageType === ImageTypeEnum.EMPTY) {
      dispatch(textSettingsChangeIndentRedLine(IndentRedLineEnum.EMPTY));
    }
  }, [imageType]);

  return (
        <PageListComponent
            text={text}
            pageBackgroundUrl={IMAGE_URLS[imageType]}
            fontSize={fontSize}
            lineHeight={lineHeight}
            indentRight={indentRight}
            indentLeft={indentLeft}
            indentTop={indentTop}
            fontType={fontType}
            isLoading={fontLoading}
            textColor={textColor}
            redLineIndent={indentRedLine}
            indentLetter={indentLetter}
            indentWord={indentWord}
            isRandomFontSize={isRandomFontSize}
            isRandomRotateLetter={isRandomRotateLetter}
            isRandomLineLeftIndent={isRandomLineLeftIndent}
        />
  );
};

export default ContentContainer;
